import { render, staticRenderFns } from "./dangerous-button.vue?vue&type=template&id=5448e362&"
import script from "./dangerous-button.vue?vue&type=script&lang=js&"
export * from "./dangerous-button.vue?vue&type=script&lang=js&"
import style0 from "./dangerous-button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports